/* eslint-disable node/no-unsupported-features/es-syntax */
import { CRM_ROUTE_NAMES } from "@/shared";

export const CRM_ROUTES = [
    {
        name: CRM_ROUTE_NAMES.BOARD,
        path: "/crm",
        meta: {
            title: "CRM",
        },
        component: () => import("../ui/CrmBoard.vue"),
    },
];
